<template>
  <div class="viewer-wrapper" @contextmenu="handler($event)">
    <viewer :options="options" :images="images"
            @inited="inited"
            class="viewer" ref="viewer"
    >
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper" v-for="{source, thumbnail, alt} in scope.images" :key="source">
            <img class="image d-none"
                  :src="thumbnail" :data-source="source" :alt="alt"
            >
          </div>
        </figure>
      </template>
    </viewer>
    <v-btn class="printer" absolute left top fab dark color="indigo" @click="printImage" >
      <v-icon dark>print</v-icon>
    </v-btn>
  </div>
</template>

<script>

import axios from "axios";
import { Printd } from 'printd'
// import { bus } from "./../main";
var configBaseAxios = {
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'x-www-form-urlencoded',
  },
  params: {}
}

export default {
  mounted () {
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"))
    Promise
      .all([this.getArchivos()])
      .then(() => {
        // console.log('promesa lista')
        this.viewImage()
      })
      .catch(reason => {
        console.log('Fail', reason)
        //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
      })
  },
  data () {
    return {
      pagename: 'Editar Examen',
      logged_user: null,
      archivos: [],
      options: {
        inline: true,
        button: false,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
        print: true,
      },
      images: [],
      viewMenu: false,
      top: '0px',
      left: '0px'
    }
  },

  computed: {
  },

  methods: {
    inited (viewer) {
      this.$viewer = viewer
    },
    getArchivos () {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: 'archivos',
          opcion: 'listarArchivo',
          id_examen: this.$route.params.id_examen,
          api_token: this.logged_user.api_token
        }
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then(result => {
            if (result.data.response) {
              this.archivos = result.data.callback
              // console.log('archivos', JSON.parse(JSON.stringify(this.archivos)))
              resolve()
            } else {
              reject('No data result')
            }
          })
          .catch(error => {
            reject('Error ajax')
          })
      })
    },

    async viewImage () {
      this.images = this.archivos.filter(file => file.tipo == this.$route.params.type)
      this.images.forEach(image => {           
        image.title = image.nombrePaciente
        switch(this.$route.params.type) {
          case 'dcm': 
            image.source = window.base_path + window.filesDCM + image.ArchivoJPG
            image.thumbnail = window.base_path + window.filesDCM + image.ArchivoJPG
            // image.alt = 'Imagen paciente: ' + image.nombrePaciente + ' (fecha exam. '+ image.fechaHoraexamen +')'
            image.alt = image.nombrePaciente
            break
          case 'orden':
            image.source = window.base_path + window.filesORDEN + image.nomArchivo
            image.thumbnail = window.base_path + window.filesORDEN + image.nomArchivo
            image.alt = 'Orden'
            break
        }
        //console.log('img', type, image.src)
      })
      //this.loadingExams = true
      setTimeout(()=>{
        // this.viewer = this.$refs['viewer'].$viewer
        // this.viewer.show()
        this.inited()
        //this.loadingExams = false
      }, 1000)
    },

    handler: function(e) {
      //do stuff
      console.log('RCLICK')
      e.preventDefault();
    },

    printImage: function() {
      let printable = document.getElementsByClassName('viewer-canvas')[0]
      const d = new Printd()
      d.print( printable )
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .viewer-wrapper {
    position: relative;
    background: #333;
    height: 100%;
  }

  .methods {
    margin-bottom: 1em;
    flex-wrap: wrap;

    & > * {
      margin-right: 0.75rem;
    }
  }

  .options-panel {
    .panel-block {
      padding: 0;

      .checkbox {
        display: block;
        width: 100%;
        margin: 0;
        padding: 0.5em 0.75em;
      }
    }
  }

  .viewer {
    height: 100%;

    .images {
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 5px;

      .image-wrapper {
        display: inline-block;
        width: calc(33% - 20px);
        margin: 5px 5px 0 5px;

        .image {
          width: 100%;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }

  .printer {
    top: 15px;
  }
</style>

<style scoped>
  .viewer-wrapper >>> .viewer-title{
    font-size: 1.5rem;
  }
  .viewer-wrapper >>> .image-wrapper h3 {
    color: white;
    position: relative;
    bottom: 0;
  }
</style>